// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"theme__wrapper___2S6Rg","dialog":"theme__dialog___3yAsn","active":"theme__active___2Bq2z","small":"theme__small___10W_I","normal":"theme__normal___3Fsqk","large":"theme__large___3NigS","fullscreen":"theme__fullscreen___1KTed","title":"theme__title___3kwKw","body":"theme__body___2g6Ah","navigation":"theme__navigation___1c5Z_","button":"theme__button___3X35J"};


//////////////////
// WEBPACK FOOTER
// ./~/@luminopia/react-toolbox/lib/dialog/theme.css
// module id = 1189
// module chunks = 0